<div class="eidos-container"
  [class]="mainClass"
  [class.eidos-container-mobile]="mobileQuery.matches && isAuthenticated">
  <eidos-topbar class="eidos-header"
    *ngIf="isAuthenticated && !hideTopbar">
  </eidos-topbar>

  <div class="eidos-body">
    <div class="eidos-body-wrapper h-100">
      <div id="content" class="h-100"
        [ngClass]="{ 'eidos-logged-in-main-container': isAuthenticated && !hideTopbar}">
        <eidos-external-app-container [hidden]="!extAppMode"></eidos-external-app-container>
        <eidos-progress-spinner *ngIf="onPrepareEnvironment"></eidos-progress-spinner>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <eidos-command-panel class="eidos-footer"></eidos-command-panel>
</div>

<eidos-modal></eidos-modal>
